import axios from "axios";

export const api = axios.create({
    //baseURL: "http://localhost:5245/api"    
    baseURL: "https://apiinformezz.mascsoftware.com.br/api"    
  });  

  export default api;